import { render, staticRenderFns } from "./DialogRegister.vue?vue&type=template&id=6d95f8fc&scoped=true&"
import script from "./DialogRegister.vue?vue&type=script&lang=js&"
export * from "./DialogRegister.vue?vue&type=script&lang=js&"
import style0 from "./DialogRegister.vue?vue&type=style&index=0&id=6d95f8fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_prettier@3.0.3_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95f8fc",
  null
  
)

export default component.exports